module.exports = __webpack_public_path__ + "static/media/factuur.d51aea63.svg";